<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="matDeliver" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column label="编号">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="DeliverType" label="出库类型" :formatter="deliverTypeToStr"></el-table-column>
      <el-table-column prop="DepName" label="出库部门"></el-table-column>
      <el-table-column prop="WarehouseName" label="出库仓库"></el-table-column>
      <el-table-column prop="DeliverTime" label="出库日期"></el-table-column>
      <el-table-column prop="PersonName" label="经手人"></el-table-column>
      <el-table-column prop="RBFlag" label="红蓝单" :formatter="rbFlag"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canRed" type="danger" @click="() => {
              currentRow = scope.row;
              handleRed();
            }
            ">
            取消出库
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
      width="70%">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="出库类型" prop="DeliverType">
              <el-select v-model="addForm.MatDeliver.DeliverType" placeholder="请选择类别">
                <el-option label="普通出库" :value="0"></el-option>
                <el-option label="期初出库" :value="100"></el-option>
                <el-option label="过磅出库" :value="200"></el-option>
                <el-option label="盘点出库" :value="300"></el-option>
                <el-option label="采购申请出库" :value="400"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库日期">
              <el-date-picker v-model="addForm.MatDeliver.DeliverTime" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库人员" prop="PersonName">
              <el-input readonly v-model="addForm.MatDeliver.PersonName">
                <template slot="append">
                  <el-button type="primary" @click="opvisibleDialog = true" :loading="listLoading" size="small">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="仓库">
              <el-select v-model="addForm.MatDeliver.WarehouseID" filterable @change="whChange">
                <el-option v-for="material in basedata.WarehouseList" :label="material.Name" :key="material.Id + '_wh'"
                  :value="material.Id" v-model="material.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类别">
              <el-radio-group v-model="addForm.MatDeliver.RBFlag">
                <el-radio :label="0">蓝字单</el-radio>
                <el-radio :label="1">红字单</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注">
              <el-input v-model="addForm.MatDeliver.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="打印抬头">
          <el-input v-model="addForm.MatDeliver.PrintTitle"></el-input>
        </el-form-item>
      </el-form>
      <!-- 详情 -->
      <el-form>
        <el-row :gutter="5" type="flex" justify="space-around" class="row-center">
          <el-col>物料信息</el-col>
          <el-col>规格</el-col>
          <el-col>编号</el-col>
          <el-col>单位</el-col>
          <el-col>账面数量</el-col>
          <el-col>账面单价</el-col>
          <el-col>账面金额</el-col>
          <el-col>数量</el-col>
          <el-col>单价</el-col>
          <el-col>金额</el-col>
          <el-col>备注</el-col>
          <el-col>操作</el-col>
        </el-row>
        <el-row :gutter="5" type="flex" justify="space-around" v-for="(item, index) in addForm.MatDeliverSub"
          :key="index">
          <el-col>
            <el-form-item>
              <el-select v-model="item.MatID" filterable @change="matChange($event, index)">
                <el-option v-for="material in basedata.MaterialList" :label="material.Name" :key="material.Id + '_mat'"
                  :value="material.Id" v-model="material.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.MatGrade"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.MatCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input class="hr-select" readonly v-model="item.UnitName">
                <template slot="append">
                  <el-button type="primary" @click="openUnitPage(index)" :loading="listLoading" size="small" class="pd-5">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodQuantity" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodPrice" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodAmount" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-input v-model="item.Quantity" @input="updateAmount"></el-input>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Price" @input="updateAmount" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Amount" @input="updateAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item style="text-align: center">
              <el-button type="danger" @click="receiveSubRemoveRow(item.Id)">
                删除
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="receiveSubAddRow">新增行</el-button>
        </el-row>
      </el-form>
      <!-- 详情 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--详情界面-->
    <el-dialog title="新增" :visible.sync="isShowDetail" v-model="isShowDetail" width="70%">
      <table class="table-bordered" style="">
        <tr>
          <th>单据编号</th>
          <td>{{ DetailDm.MatDeliver.Code }}</td>
          <th>出库日期</th>
          <td>{{ DetailDm.MatDeliver.DeliverTime }}</td>
        </tr>
        <tr>
          <th>出库类型</th>
          <td>
            {{
              DetailDm.MatDeliver.DeliverType == 0
              ? "普通出库"
              : DetailDm.MatDeliver.DeliverType == 100
                ? "期初出库"
                : DetailDm.MatDeliver.DeliverType == 200
                  ? "过磅出库"
                  : DetailDm.MatDeliver.DeliverType == 300
                    ? "盘点出库"
                    : "未定义"
            }}
          </td>
          <th>出库人员</th>
          <td>{{ DetailDm.MatDeliver.PersonName }}</td>
        </tr>
        <tr>
          <th>仓库</th>
          <td>{{ DetailDm.MatDeliver.WarehouseName }}</td>
          <th>类别</th>
          <td>{{ DetailDm.MatDeliver.RBFlag == 0 ? "蓝字单" : "红字单" }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td>{{ DetailDm.MatDeliver.Remark }}</td>
          <th>打印抬头</th>
          <td>{{ DetailDm.MatDeliver.PrintTitle }}</td>
        </tr>
      </table>
      <!--列表-->
      <el-table :data="DetailDm.MatDeliverSub" highlight-current-row style="width: 100%">
        <el-table-column prop="MatName" label="物资名称"></el-table-column>
        <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
        <el-table-column prop="MatCode" label="物资编码"></el-table-column>
        <el-table-column prop="UnitName" label="单位"></el-table-column>
        <el-table-column prop="PeriodQuantity" label="账面数量"></el-table-column>
        <el-table-column prop="PeriodPrice" label="账面单价"></el-table-column>
        <el-table-column prop="PeriodAmount" label="账面总价"></el-table-column>
        <el-table-column prop="Quantity" label="数量"></el-table-column>
        <el-table-column prop="Price" label="单价"></el-table-column>
        <el-table-column prop="Amount" label="总价"></el-table-column>
        <el-table-column prop="Remark" label="备注"></el-table-column>
      </el-table>
    </el-dialog>

    <TableDataDialog title="选择人员" :visibleDialog="opvisibleDialog" :queryMethod="opqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="opsetVisible" @callback="opdialogCallback"></TableDataDialog>

    <TableDataDialog title="操作员选择" :visibleDialog="unitvisibleDialog" :queryMethod="unitqueryData" :columns="{
      Name: {
        label: '单位',
      },
      ConvertRate: {
        label: '换算系数',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建人',
      },
    }" @getDialogVisible="unitsetVisible" @callback="unitdialogCallback"></TableDataDialog>
  </section>
</template>

<script>
import * as api from "../../api/matDeliver";
import { getMatStockDetail } from "../../api/matstock";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import { getMatUnitListPage } from "../../api/matUnit";
import TableDataDialog from "../../components/TableDataDialog";
export default {
  components: {
    Toolbar,
    TableDataDialog,
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      matDeliver: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        // Name: [
        //   { required: true, message: "请输入施工部位名称", trigger: "blur" },
        // ],
      },
      //新增界面数据
      addForm: {
        MatDeliver: {},
        MatDeliverSub: [],
      },
      opvisibleDialog: false, //出库人员选择
      unitvisibleDialog: false, //出库单位选择
      unitIndex: 0,
      basedata: [],
      subIndex: 0, //子条目Id
      //详情界面数据
      DetailDm: {
        MatDeliver: {},
        MatDeliverSub: [],
      },
      isShowDetail: false,
    };
  },
  computed: {
    //计算属性,判断是否有权删除
    // canDelete() {
    //   let index = this.buttonList.findIndex((s) => s.name === "删除");
    //   return index > -1;
    // },
    canRed() {
      let index = this.buttonList.findIndex((s) => s.name === "红冲");
      return index > -1;
    },
  },
  methods: {
    // 显示窗口
    handleDetail(row) {
      let para = {
        id: row.Id,
      };
      api.getMatDeliverDetail(para).then((res) => {
        this.DetailDm = res.data.response;
      });
      this.isShowDetail = !this.isShowDetail;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getMatDeliver();
    },
    //获取出库单列表
    getMatDeliver() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getMatDeliverListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.matDeliver = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.removeMatDeliver(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getMatDeliver();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        MatDeliver: { RBFlag: 0 },
        MatDeliverSub: [],
      };
    },
    //显示红冲页面
    handleRed() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let para = {
        id: row.Id,
      };
      api.getMatDeliverDetail(para).then((res) => {
        this.addForm = res.data.response;
        this.addFormVisible = true;
        this.addForm.MatDeliver.Code = "";
        this.addForm.MatDeliver.RBFlag = 1;
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addMatDeliver(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getMatDeliver();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.getMatDeliver();
    },
    opdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.MatDeliver.PersonID = data[0].Id;
        this.addForm.MatDeliver.PersonName = data[0].Name;
      }
      this.opvisibleDialog = false;
    },
    opqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    opsetVisible(val) {
      this.opvisibleDialog = val;
    },

    unitdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.MatDeliverSub[this.unitIndex].UnitID = data[0].Id;
        this.addForm.MatDeliverSub[this.unitIndex].UnitName = data[0].Name;
        this.addForm.MatDeliverSub[this.unitIndex].ConvertRate =
          data[0].ConvertRate;
        this.updateAmount();
      }
      this.unitvisibleDialog = false;
    },
    unitqueryData(params) {
      return getMatUnitListPage(params);
    },
    unitsetVisible(val) {
      this.unitvisibleDialog = val;
    },
    //获取基础数据
    getBaseData() {
      api.getMatDeliverBaseData().then((res) => {
        this.basedata = res.data.response;
      });
    },
    //获取物料规格
    matChange(Id, index) {
      var matItem = this.basedata.MaterialList.filter((x) => x.Id == Id)[0];
      this.addForm.MatDeliverSub[index].MatGrade = matItem.MatGrade;
      this.addForm.MatDeliverSub[index].MatName = matItem.Name;
      this.addForm.MatDeliverSub[index].MatCode = matItem.Code;
      this.addForm.MatDeliverSub[index].MatID = Id;
      var para = {
        matid: Id,
        warehouseID: this.addForm.MatDeliver.WarehouseID,
      };
      getMatStockDetail(para)
        .then((res) => {
          if (res && res.data && res.data.success && res.data.response) {
            this.addForm.MatDeliverSub[index].PeriodPrice =
              res.data.response.Price;
            this.addForm.MatDeliverSub[index].Price = res.data.response.Price;

            this.addForm.MatDeliverSub[index].PeriodQuantity =
              res.data.response.Quantity;
            this.addForm.MatDeliverSub[index].PeriodAmount =
              res.data.response.Amount;
          } else {
            this.addForm.MatDeliverSub[index].PeriodPrice = 0;
            this.addForm.MatDeliverSub[index].PeriodQuantity = 0;
            this.addForm.MatDeliverSub[index].PeriodAmount = 0;
            this.addForm.MatDeliverSub[index].Price = 0;
          }
        })
        .finally(() => { });
    },
    //获取仓库信息
    whChange(id) {
      var whItem = this.basedata.WarehouseList.filter((x) => x.Id == id)[0];
      this.addForm.MatDeliver.WarehouseName = whItem.Name;
      this.addForm.MatDeliver.WarehouseID = id;
    },
    //明细添加行
    receiveSubAddRow() {
      this.subIndex += 1;
      this.addForm.MatDeliverSub.push({
        Id: this.subIndex,
        UnitID: "",
        ConvertRate: 1,
        Quantity: 0,
        Price: 0,
        Amount: 0,
        UnitName: "",
        PeriodPrice: 0,
        PeriodQuantity: 0,
        PeriodAmount: 0,
      });
    },
    //明细删除行
    receiveSubRemoveRow(id) {
      this.addForm.MatDeliverSub.splice(
        this.addForm.MatDeliverSub.findIndex((x) => x.Id === id),
        1
      );
    },
    openUnitPage(index) {
      this.unitIndex = index;
      this.unitvisibleDialog = true;
    },
    updateAmount() {
      this.addForm.MatDeliverSub.map((e) => {
        e.Amount = e.Quantity * e.Price;
      });
    },
  },
  mounted() {
    this.getMatDeliver();
    this.getBaseData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  filters: {},
};
</script>

<style lang="less" scoped></style>
